import { FQAN_jedgrad_id } from '@app/components';
import { DokItemInfo } from '@app/components/dokumentacija/dokumentacija-types';
import { NtapGlobalConstants } from '@ntap/core';

/**
 * Updates item with fresh parent data from selected parent items.
 * This is a workaround for parent not being refreshed after locking/unlocking.
 */
export function updateItemWithFreshParent(
  item: any,
  selectedParentItems: any[]
): DokItemInfo {
  // nakon otključavanja/zaključavanja parent od item-a ne bude osvježen pa radimo ovaj hack
  const parentId = item[NtapGlobalConstants.ATTR_$parentId];
  const currentParent = selectedParentItems.find(
    (parentItem: any) => parentItem[FQAN_jedgrad_id] == parentId
  );
  const itemWithFreshParent = currentParent
    ? {
        ...item,
        $parent: { ...(item?.$parent ?? {}), $parent: currentParent }
      }
    : item;
  return new DokItemInfo(itemWithFreshParent);
}
